import PropTypes from 'prop-types';
import React from 'react';
import ReactCollapse from 'react-collapse';
import MediaQuery from 'react-responsive';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { Vehicle } from '@sm360/widget-commons-vehicle';
import { MEDIA_QUERIES } from '@sm360/widget-commons-general';

import 'vdp-used/components/VehicleDescription/VehicleDescription.scss';

class VehicleDescription extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            collapse: true,
            iconClass: 'reverse',
        };
        this.showMore = this.showMore.bind(this);
    }

    showMore() {
        this.setState({
            collapse: !this.state.collapse,
            iconClass: this.state.iconClass !== '' ? '' : 'reverse',
        });
    }

    render() {
        const iconDirection = ['icon-chevron-thin-down', this.state.iconClass];

        return (
            <div className="showroom-vdp-used-desc clearfix" onClick={this.showMore}>
                <h3 className="sr-subtitle-1 is-centered">
                    {LocaleService.t('VEHICLE_DESCRIPTION.ABOUT', { vehicle: this.props.vehicle.getYearMakeModel() })}
                </h3>
                <MediaQuery maxWidth={MEDIA_QUERIES.MOBILE.MAX}>
                    <icon className={iconDirection.join(' ')}>&nbsp;</icon>
                    <ReactCollapse isOpened={this.state.collapse}>
                        <p
                            className="car-desc sr-text"
                            dangerouslySetInnerHTML={{ __html: this.props.vehicle.description }}
                        />
                    </ReactCollapse>
                </MediaQuery>
                <MediaQuery minWidth={MEDIA_QUERIES.LAPTOP.MIN}>
                    <p
                        className="car-desc sr-text"
                        dangerouslySetInnerHTML={{ __html: this.props.vehicle.description }}
                    />
                </MediaQuery>
            </div>
        );
    }
}

VehicleDescription.propTypes = {
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
};

VehicleDescription.displayName = 'VehicleDescription';

export default VehicleDescription;
